import React from 'react';
import { Grid, Avatar, Typography, makeStyles, Divider, CircularProgress } from '@material-ui/core';
import PropTypes from 'prop-types';
import { CalendarToday, Close } from '@material-ui/icons';
import CustomButtonIcon from '../../Common/ButtonIcon';
import EventTourVenueDetails from './details';
import { useQueryEventTour } from '../../../hooks';

const EventTourInfo = props => {
  const useStyles = makeStyles({
    eventTour: {
      display: 'flex',
      padding: '10px',
      justifyContent: 'center',
      alignItems: 'center',
    },
    eventTourClose: {
      display: 'flex',
      justifyContent: 'flex-end',
      padding: '10px',
    },
    divider: {
      paddingTop: '0px !important',
    },
    normalLabel: {
      color: '#494949',
    },
    selectedLabel: {
      color: '#5E176A',
      fontWeight: '600',
    },
    normalContainer: {
      margin: '0px 5px 5px 5px !important',
      '&:hover': {
        backgroundColor: '#E9E9E98C',
      },
      paddingTop: '5px',
      borderRadius: '5px',
    },
    selectedContainer: {
      margin: '0px 5px 5px 5px !important',
      backgroundColor: '#F6EBF8',
      borderRadius: '5px',
    },
    loadingContent: {
      padding: '15px',
    },
  });
  const { eventMeta, close, action } = props;
  const { name } = eventMeta;
  const classes = useStyles();
  const { data, isFetching } = useQueryEventTour(eventMeta.skybox_id);

  return (
    <>
      {close && (
        <Grid container className={classes.eventTourClose}>
          <Grid item xs={1}>
            <CustomButtonIcon size="small" onClick={() => action(false)} width="30px" height="30px">
              <Close />
            </CustomButtonIcon>
          </Grid>
        </Grid>
      )}
      <Grid container className={classes.eventTour} spacing={2}>
        <Grid item xs={2}>
          <Avatar aria-label="Calendar" style={{ background: '#7D1F8D', width: '30px', height: '30px' }}>
            <CalendarToday style={{ color: 'white' }} />
          </Avatar>
        </Grid>
        <Grid item xs={10}>
          <Typography>{name}</Typography>
        </Grid>
        <Grid item xs={12} className={classes.divider}>
          <Divider
            style={{
              background: '#9C27B0',
            }}
          />
        </Grid>

        {isFetching ? (
          <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center' }}>
            <CircularProgress style={{ height: '60px', width: '60px' }} />
          </Grid>
        ) : (
          (data &&
            data.response &&
            Array.isArray(data.response) &&
            data.response.length > 1 &&
            data.response.map(item => (
              <EventTourVenueDetails
                key={item.event_id}
                id={item.event_id}
                item={item}
                selected={eventMeta.event_id === item.event_id}
              />
            ))) || <EventTourVenueDetails noEvents />
        )}
      </Grid>
    </>
  );
};

EventTourInfo.propTypes = {
  eventMeta: PropTypes.object.isRequired,
  action: PropTypes.func.isRequired,
  close: PropTypes.bool.isRequired,
};

export default EventTourInfo;
